import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Index from "./pages/Index";
import Login from "./pages/Login";
import Signup from "./pages/Signup";

import IstoryBoard from "./pages/istoryBoard";
import DataAnalysis from "./pages/DNA";

import { Box, CircularProgress } from "@mui/material";
import useFetch from "./components/useFetch";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import  Segmentation  from "./pages/segmentation";
import Home from "./pages/home";
import { useSelector } from "react-redux";
import HealthX from "./pages/health";
import ManufactureX from "./pages/manufacturex";
import MayiiqX from "./pages/MayiiqX"
import KnowledgeX from "./pages/knowledgex";
import OnboardingX from "./pages/onboardingx";
import SchedulerX from "./pages/schedulerx";


function App() {
	// const { loading, error, websiteContent } = useFetch(`https://cms.istorylive.com/api/nlu-websites/1/?populate=*`);
  
	// if (loading) {
	// 	return (
	// 		<Box
	// 			display="flex"
	// 			justifyContent="center"
	// 			alignItems="center"
	// 			height="100vh"
	// 		>
	// 			<CircularProgress />
	// 		</Box>
	// 	);
	// }
	// if (error) return <p> Error : </p>;
	let token = useSelector(state=>state.initialData?.login_token)
	return (
		<>
			<div>
			<Routes>
  {/* Public routes — no login required */}
  <Route path="/" element={<Home />} />
  <Route path="/dashboard" element={<Home />} />
  <Route path="/assitive_ai" element={<IstoryBoard />} />

  {/* Login page — redirects to dashboard if already logged in */}
  <Route path="/login" element={token ? <Navigate to="/dashboard" /> : <Login />} />

  {/* Protected routes — require login */}
 
  <Route
  path="/csv_qa"
  element={token === "dataaccess" ? <DataAnalysis /> : <Navigate to="/login" />}
/>
<Route
  path="/segmen_ai"
  element={token === "dataaccess" ? <Segmentation /> : <Navigate to="/login" />}
/>
<Route
  path="/scheduler_x"
  element={token === "dataaccess" ? <SchedulerX /> : <Navigate to="/login" />}
/>
<Route
  path="/health_x"
  element={token === "dataaccess" ? <Navigate to="/scheduler_x" /> : <Navigate to="/login" />}
/>
<Route
  path="/manufac_x"
  element={token === "dataaccess" ? <Navigate to="/scheduler_x" /> : <Navigate to="/login" />}
/>
<Route
  path="/mayiiqx"
  element={token === "dataaccess" ? <MayiiqX /> : <Navigate to="/login" />}
/>
<Route
  path="/knowledge_x"
  element={token === "dataaccess" ? <KnowledgeX /> : <Navigate to="/login" />}
/>
<Route
  path="/onboarding_x"
  element={token === "dataaccess" ? <OnboardingX /> : <Navigate to="/login" />}
/>



</Routes>





			</div>
		</>
	);
}

export default App;
